export default __webpack_public_path__ + "static/media/key-rotated-unlocked.37a18c54.svg";